export const APP_ADD_NOTIFICATION = 'App.Notification.Add';
export const APP_HIDE_NOTIFICATION = 'App.Notification.Hide';
export const APP_REMOVE_NOTIFICATION = 'App.Notification.Remove';
